import React, { Fragment, useEffect, useReducer, useState } from "react";

import styles from "./Review.module.css";
import ReviewKCard from "./ReviewKCard";

const reducer = function (state, action) {
  switch (action.type) {
    case "SET_INDEX":
      return { ...state, index: action.payload };
    case "SET_TEST":
      return { ...state, testSet: action.payload };
    case "SET_TEST_AND_INDEX":
      return {
        ...state,
        testSet: action.payload.testSet,
        index: action.payload.index,
      };
    case "SET_COMPLETE":
      return { ...state, complete: true };
  }
};

const playTTS = function (lang, word) {
  try {
    var source = `https://translate.google.com/translate_tts?tl=${lang}&q=${encodeURIComponent(
      word
    )}&client=tw-ob`;
    var audio = new Audio(source);
    audio.play();
  } catch (err) {
    console.dir(err);
  }
};

const Review = function (props) {
  const [state, dispatch] = useReducer(reducer, {
    testSet: [{ result: "", query: "", imgUrl: "" }],
    index: 0,
    complete: false,
  });

  const [isFlipped, setIsFlipped] = useState(false);

  useEffect(() => {
    const newTestSet = props.collection.map((card) => {
      const newCard = {
        query: card.query,
        result: card.result,
        imgUrl: card.imgUrl,
        outputLang: card.outputLang,
      };

      return newCard;
    });
    dispatch({ type: "SET_TEST", payload: newTestSet });
  }, [props.collection]);

  const selectKCardIndex = function (collection) {
    const setSize = collection.length;
    const randIndex = Math.floor(Math.random() * setSize);
    return randIndex;
  };

  useEffect(() => {
    const newRandIndex = selectKCardIndex(props.collection);
    dispatch({ type: "SET_INDEX", payload: newRandIndex });
  }, [props.collection]);

  useEffect(() => {
    const kcard = state.testSet[state.index];
    if (!kcard.result) return;
    playTTS(kcard.outputLang, kcard.result);
  }, [state.index]);

  const flipHandler = function (e) {
    if (e.target.tagName === "BUTTON") return;
    setIsFlipped(true);
  };

  const submitHandler = function () {
    if (state.testSet.length === 1) {
      dispatch({
        type: "SET_COMPLETE",
      });
      return;
    }

    const newTestSet = [
      ...state.testSet.slice(0, state.index),
      ...state.testSet.slice(state.index + 1, state.testSet.length),
    ];
    const newRandIndex = selectKCardIndex(newTestSet);
    setTimeout(
      () =>
        dispatch({
          type: "SET_TEST_AND_INDEX",
          payload: {
            testSet: newTestSet,
            index: newRandIndex,
          },
        }),
      250
    );
    setIsFlipped(false);
  };

  const retryHandler = function () {
    setIsFlipped(false);
    const newRandIndex = selectKCardIndex(state.testSet);
    setTimeout(
      () => dispatch({ type: "SET_INDEX", payload: newRandIndex }),
      250
    );
  };

  if (props.collection.length === 0) {
    return (
      <p className={styles["no-cards"]}>You have not created any cards 😢</p>
    );
  }

  return (
    <Fragment>
      {!state.complete && (
        <div className={styles.container} onClick={flipHandler}>
          <div className={styles.stats}>
            <p>Cards left: {state.testSet.length}</p>
          </div>
          <ReviewKCard
            data={state.testSet[state.index]}
            className={isFlipped && styles.flip}
            onSubmitHandler={submitHandler}
            onRetryHandler={retryHandler}
          />
        </div>
      )}
      {state.complete && (
        <div className={styles.container}>
          <h1>Test Complete</h1>
        </div>
      )}
    </Fragment>
  );
};

export default Review;
